import { SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';

export class AchievementBadgeResultDto {
    id: number;
    name: string;
    description: string;
    badgeImageUrl: string;

    // Transient Fields
    showRemoteBadgeImage = false;
    remoteBadgeImage: Observable<string | SafeUrl>;

    get localBadgeImage(): string {
        return `assets/images/achievements/${this.id}.png`;
    }

    get unknownBadgeImage(): string {
        return `assets/images/achievements/unknown_badge.png`;
    }
}
